import * as tslib_1 from "tslib";
export function convertSnaps(snaps) {
    return snaps.map(function (snap) {
        var data = snap.payload.doc.data();
        var id = snap.payload.doc.id;
        return tslib_1.__assign({ id: id }, data);
    });
}
